import React, { useEffect } from "react";
import SectionHeader from "@/components/common/SectionHeader";
import { Truck, Package, ClipboardCheck, FileText, Ship, Building2, Handshake, ShieldCheck, Warehouse, Users } from "lucide-react";

const SERVICES = [
  { icon: Handshake, title: "Agricultural Commodity Sourcing", body: "Product-first sourcing across rice, pulses, cereals, millets, spices and oilseeds — matched to buyer specifications." },
  { icon: Users, title: "Bulk Procurement Coordination", body: "Volume procurement coordination for distributors, processors and trading partners." },
  { icon: Building2, title: "Supplier & Mill Coordination", body: "Working with reliable mills and supply partners across India's agricultural belts." },
  { icon: ClipboardCheck, title: "Buyer-Specific Product Matching", body: "Variety, grade, grain size, moisture and purity matched to the buyer's exact brief." },
  { icon: Package, title: "Packaging Coordination", body: "PP, BOPP, jute, custom-labelled and buyer-specific packaging arranged through partners." },
  { icon: ShieldCheck, title: "Quality Inspection Coordination", body: "Pre-shipment inspections and sampling coordinated with third-party inspection partners." },
  { icon: FileText, title: "Export Documentation Coordination", body: "Coordination of Certificate of Analysis, phytosanitary and shipment documentation with partners." },
  { icon: Ship, title: "Freight & Logistics Coordination", body: "Container stuffing, port handling and freight coordination through trusted logistics partners." },
  { icon: Warehouse, title: "Import & Export Facilitation", body: "Support for structured import and export transactions with clear commercial terms." },
  { icon: Truck, title: "Domestic B2B Supply", body: "Coordinated supply for domestic distributors, retail chains and processors within India." },
];

export default function ServicesPage() {
  useEffect(() => { document.title = "Services — Aaha Kanakam Traders"; }, []);
  return (
    <div data-testid="services-page">
      <section className="bg-forest text-white py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
          <div className="eyebrow text-gold mb-3">Services</div>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight max-w-3xl">End-to-end sourcing and trade coordination.</h1>
          <p className="mt-5 max-w-2xl text-white/70">A B2B services portfolio designed to make agricultural commodity trade reliable, professional and specification-driven.</p>
        </div>
      </section>
      <section className="py-20 md:py-24 bg-ivory">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <div key={s.title} data-testid={`service-card-${i}`} className="p-7 bg-white border border-borderSubtle card-hover">
              <div className="w-12 h-12 bg-forest text-gold flex items-center justify-center mb-5"><s.icon size={22} /></div>
              <div className="font-serif text-xl text-forest mb-2">{s.title}</div>
              <p className="text-sm text-slateneutral leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
        <div className="max-w-4xl mx-auto text-center mt-14 px-4">
          <p className="text-xs text-slateneutral italic">Services marked as "coordination" are performed in partnership with trusted third-party inspection agencies, mills, packaging partners, freight forwarders and customs brokers. We do not represent ourselves as a customs broker, freight forwarder, laboratory or manufacturer.</p>
        </div>
      </section>
    </div>
  );
}
